export default "<div id=\"work-actions-chart-gantt\"></div>\n"